<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h5>{{ $t('menu.incomesReport') }}</h5>
                <div class="p-grid">
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Calendar ref="startDateCalendar" style="width: 100%" dateFormat="dd.mm.yy" :showTime="true" hourFormat="24" :showIcon="true" :showButtonBar="true" v-model="startDateModel"></Calendar>
                            <label>{{ $t('sportsbets.startDate') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Calendar style="width: 100%" dateFormat="dd.mm.yy" :showTime="true" hourFormat="24" :showIcon="true" :showButtonBar="true" v-model="endDateModel"></Calendar>
                            <label>{{ $t('sportsbets.endDate') }}</label>
                        </span>
                    </div>
                    <div class="p-col-6 p-md-7 p-text-right"><Button type="button" :loading="isReportLoading" :label="$t('buttons.show')" class="p-button-raised p-button-success" @click="showReport()" /></div>
                    <div class="p-col-6 p-md-1 p-text-right">
                        <Button type="button" :label="$t('buttons.saveXls')" :loading="isReportDownloading" icon="pi pi-download" class="p-button-raised p-button-info" @click="saveXls()" />
                    </div>
                    <transition-group name="p-message" tag="div" class="p-col-12">
                        <Message :key="errorKeyCount" :severity="'error'" v-show="showError">{{ $t('alerts.generalError') }}</Message>
                    </transition-group>
                </div>
                <div class="card" v-if="showReportData">
                    <DataTable @page="onPage($event)" :paginator="true" :rows="perPage" class="p-mt-3" ref="datatable" responsiveLayout="scroll" :paginatorBottom="true" :value="reportData">
                        <Column>
                            <template #body="slotProps">
                                <span class="indexColumn">{{ (this.crtPage - 1) * this.perPage + slotProps.index + 1 }}</span>
                            </template>
                        </Column>
                        <Column :header="$t('system.code')" field="ShopCode" :sortable="true"> </Column>
                        <Column :header="$t('system.shop')" field="ShopName" :sortable="true"> </Column>
                        <Column field="IncomesTotal" :header="$t('reports.incomes')" :sortable="true">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.IncomesTotal) }} </template></Column
                        >
                        <Column field="StakeTotal" :sortable="true" :header="$t('reports.stake')">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.StakeTotal) }} </template></Column
                        >
                        <Column field="IncomesTaxTotal" :sortable="true" :header="$t('reports.incomesTax')">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.IncomesTaxTotal) }} </template></Column
                        >
                        <Column field="OutcomesTotal" :sortable="true" :header="$t('reports.outcomes')">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.OutcomesTotal) }} </template></Column
                        >
                        <Column field="OutcomesTaxTotal" :sortable="true" :header="$t('reports.outcomesTax')">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.OutcomesTaxTotal) }} </template></Column
                        >
                        <Column field="ShopCreditAmount" :sortable="true" :header="$t('reports.shopCreditAmount')">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.ShopCreditAmount) }} </template></Column
                        >
                        <Column field="ShopDebitAmount" :sortable="true" :header="$t('reports.shopDebitAmount')">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.ShopDebitAmount) }} </template></Column
                        >
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BoReportsApi } from '../../../service/BoReportsApi';
import { BoSaveReportsApi } from '../../../service/BoSaveReportsApi';
import { uiSettings } from '../../../settings/uiSettings';
export default {
    name: 'report',
    data() {
        return {
            reportData: [],
            term: '',
            searchTerm: '',
            BoReportsApi: new BoReportsApi(),
            BoSaveReportsApi: new BoSaveReportsApi(),
            isReportLoading: false,
            isReportDownloading: false,
            showReportData: false,
            startDateModel: null,
            endDateModel: null,
            errorKeyCount: 0,
            showError: false,
            perPage: uiSettings.tableRows,
            crtPage: 1,
        };
    },
    mounted() {
        let crtDate = new Date();
        let year = crtDate.getFullYear();
        let month = crtDate.getMonth() + 1;
        if (month <= 9) {
            month = '0' + month;
        }
        let day = crtDate.getDate();
        if (day <= 9) {
            day = '0' + day;
        }
        var startDateString = year + '-' + month + '-01' + 'T00:00';
        var endDateString = year + '-' + month + '-' + day + 'T23:59';
        this.startDateModel = new Date(startDateString);
        this.endDateModel = new Date(endDateString);
    },
    methods: {
        showReport() {
            this.showReportData = false;
            this.isReportLoading = true;
            this.BoReportsApi.getIncomesReport(this.formatEnDateAndTime(this.startDateModel), this.formatEnDateAndTime(this.endDateModel))
                .then(reportResponse => {
                    if (reportResponse.data != null) {
                        this.reportData = reportResponse.data;
                        this.tableKey++;
                    }
                    this.isReportLoading = false;
                    this.showReportData = true;
                })
                .catch(error => {
                    this.checkForUnauthorizedError(error);
                    this.showError = true;
                    this.errorKeyCount++;
                    this.isReportLoading = false;
                });
        },
        saveXls() {
            this.isReportDownloading = true;
            this.BoSaveReportsApi.saveIncomesReport(this.formatEnDateAndTime(this.startDateModel), this.formatEnDateAndTime(this.endDateModel))
                .then(response => {
                    this.isReportDownloading = false;
                    let blob = new Blob([response.data], { type: 'application/xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'IncomesReport_' + this.formatEnDateAndTime(this.startDateModel) + '_' + this.formatEnDateAndTime(this.endDateModel) + '.xlsx';
                    link.click();
                })
                .catch(error => {
                    this.checkForUnauthorizedError(error);
                    this.showError = true;
                    this.errorKeyCount++;
                    this.isReportDownloading = false;
                });
        },
        debounceSearch(event) {
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.term = event.target.value;
            }, this.debounceTime);
        },
        onPage(event) {
            this.crtPage = event.page + 1;
        },
    },
};
</script>
